// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"99":"f436c806","354":"cb3a1542","418":"1ec5ff5c"}[chunkId] + ".js";
};